
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import Sticky from '@/components/Sticky/index.vue'
import configurations from "./configurations/index"
import router from "@/router";
import GeneralForm from "@/components/GeneralForm/index.vue";
import {ElLoadingComponent} from "element-ui/types/loading";
import {replaceRouteVariables} from "@/globalFunctions";

@Component({
  name: 'FormWrapper',
  components: {
    GeneralForm,
    Sticky
  }
})
export default class extends Vue {
  @Prop({ default: false }) private configId! : string;
  @Prop({ default: false }) private accessible! : boolean;

  private loading : ElLoadingComponent;

  private dialogVisible  = false;
  private dialogReady  = false;
  private dialogTitle  = "";
  private dialogLoading  = false;
  private dialogActions  = false;
  private dialogFormValues : Record<string, unknown> = {};
  private dialogSchema: Record<string, unknown>[] | null = null;
  private onSubmitDialog : (input?: any) => any;
  private onCancelDialog : (input?: any) => any;

  private formValues : Record<string, unknown> = {};
  private getData: null | ((input?: any) => any);
  private onSubmit : (input?: any) => any;

  private tabs: Record<string, any>[] = [];
  private activeTab = '';

  @Watch('activeTab')
  private onActiveNameChange(value: string) {
    this.$router.push(`${this.$route.path}?tab=${value}`).catch(err => {
      console.warn(err)
    })
  }

  @Watch('dialogVisible')
  private onDialogVisibleChange(value: boolean){
    if (!value && !this.dialogReady){
      // Return
      this.$router.push(this.$router.currentRoute.meta.returnPage || "/dashboard");
    }
  }

  // Handlers
  mounted(){
    // Start loading
    this.loading = this.$loading({
      target: "#form-wrapper-card",
      lock: true
    });
  }

  created(){

    // Set event listeners
    this.setEventListeners();

    // Get configuration
    const config = configurations[this.configId];

    // Set config
    this.tabs = config.tabs;
    this.getData = config.getData ? config.getData : null;
    this.onSubmit = config.onSubmit ? config.onSubmit : null;

    // Set dialog
    this.dialogReady = config.dialogReady === undefined ? true : config.dialogReady;
    this.dialogVisible = config.dialogReady === undefined ? false : config.dialogReady;
    this.dialogSchema = config.dialogSchema === undefined ? false : config.dialogSchema;
    this.dialogActions = config.dialogActions === undefined ? false : config.dialogActions;
    this.onSubmitDialog = config.onSubmitDialog ? config.onSubmitDialog : null;
    this.onCancelDialog = config.onCancelDialog ? config.onCancelDialog : null;

    // Init the default selected tab
    const tab = this.$route.query.tab as string;
    if (tab) {
      this.activeTab = tab;
    } else if (this.tabs[0]){
      this.activeTab = (this.tabs[0] as any).key;
    }


    // Create form
    if (this.getData){
      this.createForm();
    } else {
      setTimeout(() => {
        this.loading?.close();
      }, 500);
    }
  }

  beforeDestroy(){
    // Remove event listeners
    this.removeEventListeners();
  }

  // Methods
  public nextTab(){
    (this.$refs.generalForm as any).nextTab();
  }
  public prevTab(){
    (this.$refs.generalForm as any).prevTab();
  }
  public submit(){
    (this.$refs.generalForm as any).submit();
  }

  private async createForm() {
    // Get form
    const data = await (this.getData !== null ? this.getData() : {});

    // Set values
    Object.keys(data).forEach(key => {
      this.$set(this.formValues, key, data[key]);
    });

    // Form ready
    setTimeout(() => {
      window.FormEvents.$emit("form-values-loaded");

      this.loading?.close();
    }, 500);
  }

  private async submitForm() {
    // Start loading
    this.loading = this.$loading({
      target: "#form-wrapper-card",
      lock: true
    });

    // On submit
    if (this.onSubmit){
      this.onSubmit(this.formValues)
          .then((result: any) => {
            if (result !== false){
              // Notify user
              this.$notify({
                title: this.$t('notifications.' + router.currentRoute.name + '-submit.success.title').toString(),
                message: this.$t('notifications.' + router.currentRoute.name + '-submit.success.message').toString(),
                type: 'success'
              });
            }

            // Go to list page
            this.$router.push(replaceRouteVariables(router.currentRoute.meta.returnPage) || "/dashboard");
          })
          .catch((error : any) => {
            // Log error
            console.error(error);

            // Notify user
            this.$notify({
              title: this.$t('notifications.' + router.currentRoute.name + '-submit.error.title').toString(),
              message: this.$t('notifications.' + router.currentRoute.name + '-submit.error.message').toString(),
              type: 'error'
            });

          }).finally(() => {
            // Done
            this.loading?.close();
          });
    } else {
      // Done
      this.loading?.close();
    }
  }

  private async submitDialogForm() {
    this.dialogLoading = true;

     if (this.onSubmitDialog){
       this.onSubmitDialog(this.dialogFormValues).then(() => {
         // Notify user
         this.$notify({
           title: this.$t('notifications.' + router.currentRoute.name + '-submit-dialog.success.title').toString(),
           message: this.$t('notifications.' + router.currentRoute.name + '-submit-dialog.success.message').toString(),
           type: 'success'
         });
       }).catch((error : any) => {
             // Log error
             console.error(error);

             // Notify user
             this.$notify({
               title: this.$t('notifications.' + router.currentRoute.name + '-submit-dialog.error.title').toString(),
               message: this.$t('notifications.' + router.currentRoute.name + '-submit-dialog.error.message').toString(),
               type: 'success'
             });
           }).finally(() => {
         // Done
         this.dialogLoading = false;
       });
     } else {
       this.dialogLoading = false;
     }

  }

  private cancelDialog(){
    // Cancel dialog
    if (this.onCancelDialog){
      this.onCancelDialog();
    }
  }

  private setEventListeners(){
    window.FormWrapperEvents.$on("toggle-dialog-actions", (enabled : boolean) => {
      this.dialogActions = enabled;
    });

    window.FormWrapperEvents.$on("toggle-dialog-loading", (enabled : boolean) => {
      this.dialogLoading = enabled;
    });

    window.FormWrapperEvents.$on("toggle-dialog-ready", (enabled : boolean) => {
      this.dialogReady = enabled;
    });

    window.FormWrapperEvents.$on("toggle-dialog-visible", (enabled : boolean) => {
      this.dialogVisible = enabled;
    });
  }

  private removeEventListeners(){

  }

  private async onEvent(func : string, event : unknown){
    // Get configuration
    const config = configurations[this.configId];

    // Run function if it exists
    if (config[func]){
      // Run function
      config[func](event);
    }
  }
}
